import * as React from "react";

const PodEmail: React.FC = () => (
    <svg width="20" height="15" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M18.125 0C19.1406 0 20 0.859375 20 1.875V13.125C20 14.1797 19.1406 15 18.125 15H1.875C0.820312 15 0 14.1797 0 13.125V1.875C0 0.859375 0.820312 0 1.875 0H18.125ZM18.125 1.875H1.875V3.47656C2.73438 4.21875 4.14062 5.3125 7.10938 7.65625C7.77344 8.16406 9.0625 9.41406 10 9.375C10.8984 9.41406 12.1875 8.16406 12.8516 7.65625C15.8203 5.3125 17.2266 4.21875 18.125 3.47656V1.875ZM1.875 13.125H18.125V5.89844C17.2266 6.60156 15.9375 7.61719 14.0234 9.14062C13.125 9.80469 11.6406 11.2891 10 11.25C8.32031 11.2891 6.79688 9.80469 5.9375 9.14062C4.02344 7.61719 2.73438 6.60156 1.875 5.89844V13.125Z"
            fill="#005EAA"
        />
    </svg>
);

export default React.memo(PodEmail);
